/* App root — providers + routing. Session gates the shell; the eight surfaces
   are deep-linkable routes under the shell layout; /login is standalone. */
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SessionProvider, RequireAccess } from './session';
import { ChromeProvider } from './chrome';
import { OpsProvider } from './ops';
import { AppShell } from './shell/AppShell';
import { Login } from './screens/Login';
import { Command } from './screens/Command';
import { Plan } from './screens/Plan';
import { Crew } from './screens/Crew';
import { Site } from './screens/Site';
import { Code } from './screens/Code';
import { Money } from './screens/Money';
import { Reviews } from './screens/Reviews';
import { Performance } from './screens/Performance';
import { Controls } from './screens/Controls';

export function App() {
  return (
    <SessionProvider>
      <ChromeProvider>
        <OpsProvider>
          <BrowserRouter>
            <Routes>
              {/* Public front door — the branded login card, no data. */}
              <Route path="/" element={<Login />} />
              {/* The dashboard SPA, served under /app. Gated by Cloudflare Access
                  at the edge AND by RequireAccess in the client, so the shell
                  never mounts without a verified Access identity. */}
              <Route path="/app" element={<RequireAccess><AppShell /></RequireAccess>}>
                <Route index element={<Navigate to="/app/command" replace />} />
                <Route path="command" element={<Command />} />
                <Route path="plan" element={<Plan />} />
                <Route path="crew" element={<Crew />} />
                <Route path="site" element={<Site />} />
                <Route path="code" element={<Code />} />
                <Route path="money" element={<Money />} />
                <Route path="controls" element={<Controls />} />
                <Route path="reviews" element={<Reviews />} />
                <Route path="performance" element={<Performance />} />
                <Route path="*" element={<Navigate to="/app/command" replace />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </OpsProvider>
      </ChromeProvider>
    </SessionProvider>
  );
}
